export const RESERVED_FIELD_KEYS = {
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  phone: 'phone',
  birth_date: 'birth_date',
  address: 'address',
} as const;

export type ReservedFieldKey = typeof RESERVED_FIELD_KEYS[keyof typeof RESERVED_FIELD_KEYS];
